import React, { useState } from "react";
import HeaderThree from "../../../components/header/HeaderThree";
import { Helmet } from "react-helmet";
import CoreComponent25 from "../../../assets/Sub-component/CoreComponent25";
import CoreComponent9 from "../../../assets/Sub-component/CoreComponent9";
import CoreComponent29 from "../../../assets/Sub-component/CoreComponent29";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import { Link } from "react-router-dom";

import Cuts_costs from "../../../assets/Services/AI_dev/Cuts_costs.svg";
import Elevate_revenue from "../../../assets/Services/AI_dev/Elevate_revenue.svg";
import Enrich_customer from "../../../assets/Services/AI_dev/Enrich_customer.svg";
import Generate_and_outshine from "../../../assets/Services/AI_dev/Generate_and_outshine.svg";
import Prevents_risks from "../../../assets/Services/AI_dev/Prevents_risks.svg";
import Refine_decision from "../../../assets/Services/AI_dev/Refine_decision-making.svg";

import AI_Assistance from "../../../assets/Services/Ai_development/Ai_img/AI_Assistance.jpg";
import AI_strategy_consulting from "../../../assets/Services/Ai_development/Ai_img/AI_strategy_consulting.jpg";
import AI_Rollout_and_Integration from "../../../assets/Services/Ai_development/Ai_img/AI_Rollout_and_Integration.jpg";
import Develop_Advanced_AI_Solutions_for_Enterprises from "../../../assets/Services/Ai_development/Ai_img/Develop_Advanced_AI_Solutions_for_Enterprises.jpg";
import Intelligent_Cloud_Services from "../../../assets/Services/Ai_development/Ai_img/Intelligent_Cloud_Services.jpg";
import Personalized_AI_solution from "../../../assets/Services/Ai_development/Ai_img/Personalized_AI_solution.jpg";
import task from "../../../assets/Services/Ai_development/Ai_img/task.jpg";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";

const AIDevelopmentCompany = () => {
   const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const header = [
    {
      title: " AI Developers ",
      num: "10 +",
    },
    {
      title: " Years of Expertise",
      num: "5+",
    },
    {
      title: "Countries Served",
      num: "10+",
    },
    {
      title: "Happy Clients   ",
      num: " 650+",
    },
  ];

  const ourblogs = [
    {
      icon: Personalized_AI_solution,
      title: "Personalized AI solution",
      desc: "We are proficient in delivering personalized AI solutions that align with our clients’ unique vision, from natural language processing to deep learning models. We specialize in innovative systems customized to specific business needs.",
    },
    {
      icon: AI_strategy_consulting,
      title: "AI strategy consulting",
      desc: "If you are planning to develop AI applications and need the right direction. Our AI consulting services can help you with the best ideas and strategies for a fully operational AI solution ",
    },
    {
      icon: AI_Rollout_and_Integration,
      title: "AI Rollout and Integration",
      desc: "At Raiden Labs, we help systematically deploy AI solutions into your existing systems. Our AI integration services ensure a smooth and organized transition, maximizing the impact of AI on your business activity ",
    },
    {
      icon: task,
      title: "Task automation",
      desc: "As a reliable AI app development company, we are experts in delivering AI automation solutions that build up your operational efficiency and optimize business activities across multiple industries ",
    },
    {
      icon: AI_Assistance,
      title: "AI Assistance",
      desc: "We are trusted AI development company offering in-depth AI support to enhance quality, performance, and speed, ultimately boosting overall business performance",
    },
    {
      icon: Intelligent_Cloud_Services,
      title: "Intelligent Cloud Services ",
      desc: " Provide AI-powered tools and infrastructure through the cloud, enabling smarter, automated, and data-driven business operations. They help organizations scale efficiently without the need for in-house AI expertise.",
    },
  ];

  const softwarebenifitbox = [
    {
      icon: Enrich_customer,
      title: " Enrich customer experience  ",
      desc: "AI enables businesses to easily customize the customer experience. By the use of chatbots that are powered by  natural language processing, which creates natural conversation with the user, enhancing satisfaction and interaction ",
      class: "true",
    },
    {
      icon: Refine_decision,
      title: "Refine decision-making  ",
      desc: " AI supports wiser decision-making by delivering smart analytics and precise predictions. This allows the business to boost efficiency and reduce risks, and make more informed, calculated choices  ",
      class: "true",
    },
    {
      icon: Generate_and_outshine,
      title: " Generate and outshine ",
      desc: " AI allows companies to create unique, innovative value creations that set them apart in a highly competitive world. By utilizing AI, companies can innovate and outshine the distinct competitive edge of the market ",
      class: "true",
    },
    {
      icon: Cuts_costs,
      title: " Cuts costs ",
      desc: " AI helps decrease Mobile App Development costs by automating routine tasks and coordinating processes. Additionally, AI-powered fraud detection reduces potential losses. Ultimately  cuts the cost of business and operates more effectively  ",
      class: "true",
    },
    {
      icon: Elevate_revenue,
      title: "Elevate revenue ",
      desc: "Implementing  AI into your business develops for overall process for customers and leads to higher sales and engagement. This turns and drives increased revenue and delivers a greater return on investment  ",
      class: "true",
    },
    {
      icon: Prevents_risks,
      title: "Prevents risks   ",
      desc: " One of the key advantages of AI for business is its lower risks. AI algorithms can quickly identify the trends and variations, and potential trends that are often unnoticed by human detection. Helps the business to take measures for operational stability  ",
      class: "true",
    },
  ];
  const handleClick=(e)=>{
   console.log(form)
   console.log("data submitted successfully") 
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   
  
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <div>
      <div className="main-page-wrapper">
        <Helmet>
          <title>
            Customer Support || Deski-Saas & Software React Template
          </title>
        </Helmet>

        <HeaderThree />
        <div className=" container ">
          <div className=" row  justify-content-center   d-flex align-items-center height-vh topheader-margin">
            <div className="col-lg-6">
              <h1 className="me-lg-5  mb-3 lh-sm  h2-heading">
                AI development company
              </h1>
              <p className="me-lg-5  mb-3 lh-base  h1-para lh-base">
                Build up your customer service with innovative AI development
                services. As a leading AI software development company, we
                invent AI app solutions that are customized for your business
                needs, with the flexibility to personalize to your specific
                needs
              </p>
              <div className="d-flex justify-content-center justify-content-lg-start">
                <Link to="/request-quote">
                  <button className="h1-para mt-lg-3 py-lg-2 py-2 px-lg-3 px-2 btn-gradient border-0 text-white rounded-4">
                    Get Your Free Quote
                  </button>
                </Link>
              </div>
            </div>

            <Contact/>
          </div>
        </div>

        <div className="container mb-80 marb ">
          <CoreComponent25 header={header} />
        </div>

        <div className="container">
          <h2 className="text-center my-3 lh-sm  h2-heading ">
            AI solutions we offer
          </h2>
          <p className="text-center mb-4  h1-para lh-base ">
            Raiden Labs is a premier AI app development company, delivering
            innovative, advanced solutions to clients. Teaming up with us
            ensures top-quality results you can rely on. We provide a wide range
            of AI Mobile App Development services
          </p>

          <div className="row">
            {ourblogs.map((val, i) => (
              <div className="col-lg-4 mb-4 col-md-6 " key={i}>
                <div className="p-3 border border-dark rounded-4 mb-4 h-100  ">
                  <img
                    src={val.icon}
                    alt=""
                    className="rounded-3  w-100"
                    style={{ height: 200 }}
                  />
                  <div className="rounded-3 p-2">
                    <div style={{ minHeight: 100 }}>
                      <h3 style={{ fontSize: 20 }} className="mb-2 mt-2">
                        {val.title}
                      </h3>
                      <p className="fs-6">{val.desc}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="container mt-80 mart ">
          <div className="row bg-black p-5 rounded-4">
            <div className="col-lg-8 text-center text-lg-start">
              <h3 className="text-white h3-heading lh-base">
                Supercharge your business with the best mobile software
                development company!
              </h3>
              <div className="d-lg-flex justify-content-center justify-content-lg-start">
                <Link to="/request-quote">
                  <button className="h1-para mt-lg-3 mt-3 py-lg-2 py-2 px-lg-3 px-2 btn-gradient border-0 text-white rounded-4">
                    Get Your Free Quote
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 d-none d-lg-block ">
              {/* <img src={Develop_Advanced_AI_Solutions_for_Enterprises} alt="" /> */}
            </div>
          </div>
        </div>

        <div className="container mt-80">
          <div className="row">
            <div className="col-lg-6">
              <div className=" position-sticky z-3" style={{ top: 100 }}>
                <h2 className="mb-2 h2-heading lh-sm ">
                  AI impact on business performance
                </h2>
                <p className="mb-2 h1-para lh-base ">
                  AI is one of today‘s most powerful technologies, boosting
                  business growth when combined with AI and ML Development,
                  which helps to generate more leads and enhance user
                  engagement. Integrating AI into multiple business operations
                  offers massive advantages, including improved quality, Smarter
                  decision making, and enhanced customer experience
                </p>
                <Link to="/request-quote">
                  <button className="btn-gradient px-3 py-2 rounded-4 text-white  mt-3">
                    let's talk
                  </button>
                </Link>
              </div>
            </div>

            <div className=" col-lg-6 row mt-3 mt-lg-0 ">
              {softwarebenifitbox.map((val, i) => (
                <div
                  key={i}
                  className={`col-lg-6 position-sticky mb-4`}
                  style={{ zIndex: 3, top: 100 }}
                >
                  <div className="border mb-4 p-3 rounded-3 shadow h-100 bg-white">
                    <img
                      src={val.icon}
                      alt=""
                      className="mx-0 "
                      style={{ width: 44, height: 44 }}
                    />
                    <h3 className="mt-3 mb-2 fs-5 h3-heading lh-base ">
                      {val.title}
                    </h3>
                    <p className="fs-6 h3-para lh-base">{val.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="container mt-80 mart ">
          <div className="bg-black row  p-4 rounded-4">
            <div className="col-lg-6 text-white">
              <h2 className="mb-3 text-white lh-sm  h2-heading"> </h2>
              Develop Advanced AI Solutions for Enterprises
              <ul className=" list-dark h3-para lh-base ">
                <li className="mt-1">
                  {" "}
                  Apply the latest AI patterns to stay ahead in the market.{" "}
                </li>
                <li className="mt-1">
                  Develop specific AI solutions that are personalized for your
                  business dreams{" "}
                </li>
                <li className="mt-1">
                  {" "}
                  Keep updated on emerging and advanced technologies
                </li>
                <li className="mt-1">
                  {" "}
                  Integrate the most effective and stable models of AI{" "}
                </li>
                <li className="mt-1">
                  Implement powerful ML and AI technologies for enhanced
                  performance{" "}
                </li>
              </ul>
              <button className="py-2 px-3 btn-gradient mt-3 rounded-4 text-white h1-para ">
                Schedule for a call
              </button>
            </div>
            <div className="col-lg-6">
              <img src="" alt="" />
            </div>
          </div>
        </div>
        <div className="container text-center mt-80 mart ">
          <h2 className="lh-sm  h2-heading">
            Mastering the Full Spectrum of AI Development
          </h2>
          <p className="my-3   h1-para">Excellence and Successful Execution</p>
          <CoreComponent9 />
        </div>

        <div className="container mt-80 mart ">
          <h2 className=" lh-sm  h2-heading mb-3 ">
            Our Advanced Solutions Across Industries
          </h2>
          <p className="h1-para lh-base">
            Raiden Labs is the leading option for AI application development,
            which serves a wide range of industries. We deliver cost-effective,
             high-quality solutions that are customized to meet your specific
            business needs, which ensure maximum value for clients’ investment
            without compromising on quality
          </p>

          <CoreComponent29 />
        </div>
        {/* <div className="mt-80 mart  container">
          <h2 className="text-center lh-sm  h2-heading  ">
            Why TechGropse is a Trusted AI APP Development Partner?
          </h2>
          <p className="my-3  h1-para lh-base">
            TechGropse offers multiple Artificial intelligence development
            services that set us apart from the competition. Working with us
            guarantees quality. As a top AI software development company in
            Dubai, we satisfy our clients at all costs.
          </p>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div
                className=" p-3 position-relative rounded-2"
                style={{ border: "1px dashed #bfbfbf" }}
              >
                <div className="position-absolute  img-left-border">
                  <img src="" className="m-0" alt="" />
                </div>
                <h3 className="fs-5 ps-4 mb-2 lh-base h3-heading ">
                  Hybrid App Development
                </h3>
                <p className="fs-6 lh-base ps-4 h3-para lh-base ">
                  Our hybrid approach delivers cost-effective iOS apps with
                  wider reach. We build versatile applications from a single
                  codebase, ensuring consistent functionality and faster
                  deployment for a client's diverse user base.
                </p>
              </div>
            </div>

            <div className="col-lg-6 mb-4">
              <div
                className=" p-3 position-relative rounded-2"
                style={{ border: "1px dashed #bfbfbf" }}
              >
                <div className="position-absolute  img-left-border">
                  <img src="" className="m-0" alt="" />
                </div>
                <h3 className="fs-5 ps-4 mb-2 lh-base h3-heading ">
                  Hybrid App Development
                </h3>
                <p className="fs-6 lh-base ps-4 h3-para lh-base ">
                  Our hybrid approach delivers cost-effective iOS apps with
                  wider reach. We build versatile applications from a single
                  codebase, ensuring consistent functionality and faster
                  deployment for a client's diverse user base.
                </p>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div
                className=" p-3 position-relative rounded-2"
                style={{ border: "1px dashed #bfbfbf" }}
              >
                <div className="position-absolute  img-left-border">
                  <img src="" className="m-0" alt="" />
                </div>
                <h3 className="fs-5 ps-4 mb-2 lh-base h3-heading ">
                  Hybrid App Development
                </h3>
                <p className="fs-6 lh-base ps-4 h3-para lh-base ">
                  Our hybrid approach delivers cost-effective iOS apps with
                  wider reach. We build versatile applications from a single
                  codebase, ensuring consistent functionality and faster
                  deployment for a client's diverse user base.
                </p>
              </div>
            </div>

            <div className="col-lg-6 mb-4">
              <div
                className=" p-3 position-relative rounded-2"
                style={{ border: "1px dashed #bfbfbf" }}
              >
                <div className="position-absolute  img-left-border ">
                  <img src="" className="m-0" alt="" />
                </div>
                <h3 className="fs-5 ps-4 mb-2 lh-base h3-heading ">
                  Hybrid App Development
                </h3>
                <p className="fs-6 lh-base ps-4 h3-para lh-base ">
                  Our hybrid approach delivers cost-effective iOS apps with
                  wider reach. We build versatile applications from a single
                  codebase, ensuring consistent functionality and faster
                  deployment for a client's diverse user base.
                </p>
              </div>
            </div>
          </div>
        </div> */}

        <footer className="theme-footer-two pt-80 padt ">
          <div className="top-footer">
            <div className="container">
              <FooterTwo />
            </div>
          </div>
          <div className="container">
            <div className="bottom-footer-content">
              <CopyRightTwo />
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default AIDevelopmentCompany;
